// Activity events emitted by `content/categories`. Same conventions
// as `articles/events.ts`: dot-segment kind strings, source-of-truth
// constant, payloads carry only ids + slug (no user-editable content
// — subscribers re-resolve via the LinkableKind).
import { z } from 'zod';
export const CATEGORY_ACTIVITY_KINDS = {
    Created: 'category.created',
    Updated: 'category.updated',
    Moved: 'category.moved',
    Archived: 'category.archived',
    Restored: 'category.restored',
};
export const CATEGORY_ACTIVITY_KIND_GLOB = 'category.*';
export const CategoryCreatedEvent = z.object({
    type: z.literal('category.created'),
    categoryId: z.string().uuid(),
    byUserId: z.string().uuid(),
    slug: z.string(),
    name: z.string(),
    parentId: z.string().uuid().nullable(),
    occurredAt: z.string().datetime({ offset: true }),
});
export const CategoryUpdatedEvent = z.object({
    type: z.literal('category.updated'),
    categoryId: z.string().uuid(),
    byUserId: z.string().uuid(),
    /** Closed list of top-level fields the request mutated (excludes
     *  `parentId` — that's tracked separately as `category.moved`
     *  because it has cycle-prevention semantics worth a distinct
     *  audit signal). */
    changedFields: z.array(z.string()),
    occurredAt: z.string().datetime({ offset: true }),
});
export const CategoryMovedEvent = z.object({
    type: z.literal('category.moved'),
    categoryId: z.string().uuid(),
    byUserId: z.string().uuid(),
    fromParentId: z.string().uuid().nullable(),
    toParentId: z.string().uuid().nullable(),
    occurredAt: z.string().datetime({ offset: true }),
});
export const CategoryArchivedEvent = z.object({
    type: z.literal('category.archived'),
    categoryId: z.string().uuid(),
    byUserId: z.string().uuid(),
    occurredAt: z.string().datetime({ offset: true }),
});
export const CategoryRestoredEvent = z.object({
    type: z.literal('category.restored'),
    categoryId: z.string().uuid(),
    byUserId: z.string().uuid(),
    occurredAt: z.string().datetime({ offset: true }),
});
//# sourceMappingURL=events.js.map